import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../layout/layout';
import gem from '../../assets/images/sidebar/gem.png';
import user from '../../assets/images/profile/user.svg';
import singelgem from '../../assets/images/header/gem.png';
import { Form, Button, Table } from 'react-bootstrap';
import './affiliates.css';

const Affiliate = () => {
  return (
    <Layout>
      <div className='affiliate-page'>
        <div className='container'>
          <div className='affiliate-heading'>
            <h2>
              <img src={gem} alt='gem' />
              Affiliates
            </h2>
            <p>
              If you are a content creator you can contact us for promotionall
              assets and more information <Link>here.</Link>
            </p>
          </div>
          <div className='affiliate-body'>
            <Form>
              <div className='referral-box'>
                <Form.Group>
                  <Form.Label>Referral Code</Form.Label>
                  <div className='ref-input'>
                    <Form.Control type='number' placeholder='madness' />
                    <div className='ref-input-btn'>
                      <Button>Save</Button>
                    </div>
                  </div>
                </Form.Group>
                <Form.Group>
                  <Form.Label>Referral Link</Form.Label>
                  <div className='ref-input'>
                    <Form.Control
                      type='number'
                      placeholder='https://rubyroll.com/r/madness'
                    />
                    <div className='ref-input-btn ref-btn-copy'>
                      <Button className='ref-btn-copy'>Copy</Button>
                    </div>
                  </div>
                </Form.Group>
              </div>
            </Form>
            <div className='claim-body'>
              <div className='wagered-box'>
                <h6>$0.00</h6>
                <p>Total Wagered</p>
              </div>
              <div className='wagered-box'>
                <h6>$0.00</h6>
                <p>Total Claimed</p>
              </div>
              <div className='claim-box'>
                <div className='claim-box-left'>
                  <h6>$0.00</h6>
                  <p>Total Wagered</p>
                </div>
                <div className='claim-box-right'>
                  <Button>Claim</Button>
                </div>
              </div>
            </div>
            <div className='referred-user-sec'>
              <h6>Referred Users</h6>
              <div className='dice-history'>
                <Table striped bordered variant='dark' responsive>
                  <thead>
                    <tr>
                      <th>User</th>
                      <th>Registered</th>
                      <th>Wagered </th>
                      <th>Earnings</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className='transaction-value'>
                          <img src={user} alt='' /> ENT1T7
                        </div>
                      </td>
                      <td>4:09 PM</td>
                      <td>
                        <div className='transaction-value'>
                          <img src={singelgem} alt='' /> $259.25
                        </div>
                      </td>

                      <td>
                        <div className='transaction-value'>
                          <img src={singelgem} alt='' /> $259.25
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className='transaction-value'>
                          <img src={user} alt='' /> ENT1T7
                        </div>
                      </td>
                      <td>4:09 PM</td>
                      <td>
                        <div className='transaction-value'>
                          <img src={singelgem} alt='' /> $259.25
                        </div>
                      </td>

                      <td>
                        <div className='transaction-value'>
                          <img src={singelgem} alt='' /> $259.25
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <div className='transaction-value'>
                          <img src={user} alt='' /> ENT1T7
                        </div>
                      </td>
                      <td>4:09 PM</td>
                      <td>
                        <div className='transaction-value'>
                          <img src={singelgem} alt='' /> $259.25
                        </div>
                      </td>

                      <td>
                        <div className='transaction-value'>
                          <img src={singelgem} alt='' /> $259.25
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Affiliate;
